export default "__VITE_ASSET__DjCDeewe__"